import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { schools } from '../data/mockSchools';
import { cases } from '../data/mockCases';
import { articles } from '../data/mockArticles';
import { PageHeader } from '../components/common/PageHeader';
import { SchoolCard } from '../components/schools/SchoolCard';
const tabs = ['院校', '案例', '资讯'] as const;
export function MyFavorites() {
  const [tab, setTab] = useState<(typeof tabs)[number]>('院校');
  const favSchools = schools.slice(0, 3);
  const favCases = cases.slice(0, 2);
  const favArticles = articles.slice(0, 3);
  return <div className="bg-slate-50 min-h-screen pb-10" data-id="element-537">
      <PageHeader title="我的收藏" data-id="element-538" />

      <div className="bg-white sticky top-12 z-10 border-b border-slate-100" data-id="element-539">
        <div className="flex" data-id="element-540">
          {tabs.map(t => <button key={t} onClick={() => setTab(t)} className={`flex-1 py-3 text-sm relative ${tab === t ? 'text-blue-600 font-bold' : 'text-slate-600'}`} data-id="element-541">
              {t}
              {tab === t && <motion.div layoutId="fav-tab" className="absolute bottom-0 left-1/4 right-1/4 h-0.5 bg-blue-600 rounded" data-id="element-542" />}
            </button>)}
        </div>
      </div>

      <div className="p-3" data-id="element-543">
        <AnimatePresence mode="wait" data-id="element-544">
          <motion.div key={tab} initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0
        }} className="space-y-3" data-id="element-545">
            {tab === '院校' && favSchools.map(s => <SchoolCard key={s.id} s={s} saved={true} onToggleSave={() => {}} selected={false} onToggleSelect={() => {}} data-id="element-546" />)}

            {tab === '案例' && favCases.map(c => <div key={c.id} className="bg-white rounded-2xl p-4 text-left" data-id="element-547">
                  <div className="flex items-center gap-3" data-id="element-548">
                    <img src={c.avatar} alt="" className="w-11 h-11 rounded-full object-cover bg-slate-100" data-id="element-549" />
                    <div className="flex-1 min-w-0" data-id="element-550">
                      <div className="font-bold text-slate-800 text-sm" data-id="element-551">
                        {c.name} · {c.major}
                      </div>
                      <div className="text-[11px] text-slate-500 mt-0.5" data-id="element-552">
                        {c.bgSchool} · {c.bgGpa}
                      </div>
                    </div>
                  </div>
                </div>)}

            {tab === '资讯' && favArticles.map(a => <div key={a.id} className="bg-white rounded-2xl p-3 flex gap-3" data-id="element-553">
                  <img src={a.cover} alt="" className="w-20 h-16 rounded-lg object-cover bg-slate-100 shrink-0" data-id="element-554" />
                  <div className="flex-1 min-w-0 flex flex-col justify-between" data-id="element-555">
                    <div className="text-sm font-medium text-slate-800 line-clamp-2" data-id="element-556">
                      {a.title}
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1" data-id="element-557">
                      {a.tag}
                    </div>
                  </div>
                </div>)}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}